// extracted by mini-css-extract-plugin
export default {"menu":"applications_menu__rTRok","table":"applications_table__COMdN","search":"applications_search__wGB7H"};